import api from './api-v0';


// Get all projets
export const getProjets = async () => {
  try {
    const response = await api.get("/data.routes.php?param=projets")
    return response.data
  } catch (error) {
    console.error("Erreur lors de la récupération des projets:", error)
    throw error
  }
}

// Get projet by id
export const getProjetById = async (id) => {
  try {
    const response = await api.get(`/data.routes.php?param=projets&id=${id}`)
    return response.data
  } catch (error) {
    console.error(`Erreur lors de la récupération du projet ${id}:`, error)
    throw error
  }
}

